import React, { Component } from "react";
import { Card, CardBody, Progress } from "reactstrap";
import moment from "moment";
import "./style.css";
import NotificationSystem from "react-notification-system";
import WalletPanel from "./wallet-panel";
import { apiActions, alertActions, commonActions } from "../../_actions";
import { appConstants } from "../../_constants";
import { appHelpers, store } from "../../_helpers";
import PageLoading from "../utils/page.loading";
import PageError from "../utils/page.error";
import PageEmptyContent from "../utils/page.empty-content";
import { connect } from "react-redux";
import { commonService } from "../../_services";
import ViewHeader from "./view-header";
import PaginatedResult from "./wallet-table";

const ViewContent = ({ children }) => (
    <div className="view-content view-components">{children}</div>
);



class Wallets extends Component {
    constructor(props) {
        super(props);
        this.state = {
            airlines: [],
            AirlineId: "",
            startDate: new Date(),
            endDate: new Date(),
            //page error
            contentError: false, //Errors that affect content on the page
            componentError: false, //Errors generated within the component
            componentErrorMessages: [],
            error: false, //Error state mutable via Redux
            success: false, //Success message mutable via Redux
            //Notification
            notification: {
                // title: 'Default Title',
                message: "Default Message",
                level: "success",
                position: "tr",
                dismissible: true
            },
            SourceAirlineId: "",
            records: null,
            currentPage: 1,
            pageSize: 10,
            totalCount: 0,
            downloadType: "excel",
            type: "pdf"
        };

        this._notificationSystem = null;
        this._lastNotificationAdded = null;
    }



    componentDidMount() {
        this._notificationSystem = this.refs.notificationSystem;
        const reduxState = store.getState();
        const { user } = this.props;
        if (reduxState.airlinesCarriers) {
            // this.setState({airlines: this.formatAirlines(reduxState.airlinesCarriers.Results)}, () => {
                this.setState({ airlines: this.formatAirlines(reduxState.airlinesCarriers.Results) }, () => {
                if (user.OrganizationType === appConstants.ORGANIZATIONS.OTHERS && this.state.airlines) {
                    // debugger;
                    const fetch = this.state.airlines.filter((item, index) => {
                        return item.Id === user.AirlineId
                    })
                    if (Array.isArray(fetch)) {
                        this.setState({ SourceAirlineId: fetch[0].Id})
                    }
                }
            });
             
        } else {
            this.fetchAirlines();
        }
    }
    
    
    notify = (message, level) => {
        let notification = this.state.notification;
        notification["message"] = message;
        notification["level"] = level;
        notification.onRemove = this.onRemove;
        this._lastNotificationAdded = this._notificationSystem.addNotification(
            notification
        );
    };

    validateInput = () => {
        let _errs_ = [];
        let formValid = true;
        if (this.state.SourceAirlineId === '') {
          _errs_['SourceAirlineId'] = 'Please select airline';
          formValid = false;
        }
        this.setState({ componentErrorMessages: _errs_, errorMessage: false });
        return formValid;
      };


    searchAirlineWallet = (pageNumber = 1) => {
        const { dispatch } = this.props;
        const {
            SourceAirlineId, endDate, startDate, pageSize,
        } = this.state;
        if(this.validateInput()){    
       dispatch(apiActions.startRequest());
        const payload__ = {
            size: pageSize,
            from: pageNumber,

            startdate: moment(startDate).format("YYYY-MM-DD") + "T00:00:00",
            enddate: moment(endDate).format("YYYY-MM-DD") + "T23:59:59",
            AirlineId: SourceAirlineId

        };
        commonService
            .getAirlineWallet(payload__)
            .then(res => {
                if (res.status === appConstants.SUCCESS_RESPONSE) {
                    let msg = "Resources Found"
                    this.notify(msg, appConstants.NOTIFY_SUCCESS);
                    this.setState({
                        currentPage: pageNumber === 0 ? 1 : pageNumber,
                        records: res.response.AirlineWalletResponses,
                        totalCount: res.response.TotalCount
                    });
                    dispatch(apiActions.endRequest());
                } else if (res.status === appConstants.ERROR_RESPONSE) {
                    dispatch(
                        alertActions.error(
                            appHelpers.interpretErrorResponseAlt2(res.response)
                        )
                    );
                    dispatch(apiActions.endRequest());
                }
            })
            .catch(err => {
                dispatch(
                    alertActions.error(appHelpers.interpretErrorResponseAlt2(err))
                );
                dispatch(apiActions.endRequest());
            });
        }
    };


    fetchAirlines = () => {
        const {dispatch, user} = this.props;
        this.setState({contentError: false});
        dispatch(apiActions.startFullPageRequest());

        dispatch(commonActions.getAirlinesCarriers())
            .then(() => {
                const { airlinesCarriers } = this.props;
                this.setState({airlines: this.formatAirlines(airlinesCarriers.Results)} , () => {
                    if (user.OrganizationType === appConstants.ORGANIZATIONS.OTHERS && this.state.airlines) {
                        // debugger;
                        const fetch = this.state.airlines.filter((item, index) => {
                            return item.Id === user.AirlineId
                        })
                        if (Array.isArray(fetch)) {
                            this.setState({ SourceAirlineId: fetch[0].Id})
                        }
                    }
                })
                dispatch(apiActions.endRequest());
            }).catch(error => {
            let errorMessage = appHelpers.interpretErrorResponse(error);
            this.notify(errorMessage, appConstants.NOTIFY_ERROR);
            this.setState({contentError: errorMessage});
            dispatch(apiActions.endRequest());
        });
    }



    downloadExcel = () => {
        const { dispatch } = this.props;
        const { startDate, endDate, SourceAirlineId, downloadType} = this.state;
        let payload = {
            startdate: moment(startDate).format("YYYY-MM-DD") + "T00:00:00",
            enddate: moment(endDate).format("YYYY-MM-DD") + "T23:59:59",
            AirlineId: SourceAirlineId,
            Type: downloadType
        };
        dispatch(apiActions.startRequest());
        commonService.downloadWalletHistory(payload)
        .then((res) => {
            dispatch(apiActions.endRequest());
            let response = res.response;
            if (res.status === appConstants.SUCCESS_RESPONSE) {
                appHelpers.downloadFile(response.data.DownloadUrl, "wallet history")
                let msg = "Wallet History Downloaded successfully"
                this.notify(msg, appConstants.NOTIFY_SUCCESS);
            } else if (res.status === appConstants.ERROR_RESPONSE) {
                dispatch(alertActions.error(res.response));
                dispatch(apiActions.endRequest());
            }
        });
    };

    downloadPdf = () => {
        const { dispatch } = this.props;
        const { startDate, endDate, SourceAirlineId, type} = this.state;
        let payload = {
            startdate: moment(startDate).format("YYYY-MM-DD") + "T00:00:00",
            enddate: moment(endDate).format("YYYY-MM-DD") + "T23:59:59",
            AirlineId: SourceAirlineId,
            Type: type
        };
        dispatch(apiActions.startRequest());
        commonService.downloadWalletHistory(payload)
        .then((res) => {
            dispatch(apiActions.endRequest());
            let response = res.response;
            if (res.status === appConstants.SUCCESS_RESPONSE) {
                appHelpers.downloadFile(response.data.DownloadUrl, "wallet history")
                let msg = "Wallet History Downloaded successfully"
                this.notify(msg, appConstants.NOTIFY_SUCCESS);
            } else if (res.status === appConstants.ERROR_RESPONSE) {
                dispatch(alertActions.error(res.response));
                dispatch(apiActions.endRequest());
            }
        });
    };


    handleSelectChange = (payload, attribute) => {
        let currState = this.state;
        let errorMessages = this.state.componentErrorMessages;
        errorMessages[attribute] = false;
        currState[attribute] = (payload) ? payload[attribute] : ''; //Cater for setting up data and clearing data
        if (!payload) {
            currState[attribute] = '';
        }
        else {
            currState[attribute] = payload.Id;
        }
        this.setState(currState);
        this.setState({ componentErrorMessages: errorMessages });

    };

    handleDateChange = (date, target) => {
        this.setState({ [target]: date });
    };

    formatAirlines = (res) => {
        let data = [];

        for (let item of res) {
            item['cat'] = 'AirlineId';
            item['label'] = `${item.Name} (${item.Code})`;
            item['value'] = item.Code;
            data.push(item);
        }

        return data;
    };

    converter = (item) => {
        const { airlinesCarriers } = this.props;       
        const filteredAirline =  airlinesCarriers.Results.filter(airline => {
            return airline.Code === item;
        });        
        if(filteredAirline.length!==0){
            return filteredAirline[0].Name;
        }
        else{
            return item;
        }
    }
   
    
    render() {
        const { requesting, pageRequesting } = this.props;
        const { SourceAirlineId, componentErrorMessages, airlines,
             contentError,  records, totalCount,
            currentPage, pageSize } = this.state;            
        return (
            <div className="view">
                <ViewHeader />
                <ViewContent>
                    <Card className="mb-4">
                        {(pageRequesting || requesting) &&
                            !pageRequesting && (
                                <Progress
                                    striped
                                    animated
                                    color="success"
                                    value={100}
                                    className="mb-2"
                                />
                            )}
                        {/*Display loader when component content is dependent on Data from API*/}
                        {!contentError && pageRequesting && <PageLoading />}

                        {/*Display error when component fail to get Data from API*/}
                        {contentError && <PageError error={this.state.contentError} />}


                        {/*Display component content when Data is gotten from API*/}
                        {!contentError &&
                            !pageRequesting && (
                                <CardBody>
                                    <h6 className="mb-0 text-uppercase pull-left">
                                        View Wallet Balance
                                  </h6>
                                    <div className="clearfis">&nbsp;</div>
                                    <WalletPanel
                                        handleDateChange={this.handleDateChange}
                                        handleEndDateChange={this.handleDateChange}
                                        SourceAirlineId={SourceAirlineId}
                                        handleSelectChange={this.handleSelectChange}
                                        componentErrorMessages={componentErrorMessages}
                                        airlines={airlines}
                                        requesting={requesting}
                                        onSearch={this.searchAirlineWallet}
                                        user={this.props.user}
                                    />
                                    <CardBody>
                                        {!pageRequesting && records && (
                                            <div>
                                                <PaginatedResult
                                                    downloadExcel={this.downloadExcel}
                                                    downloadPdf={this.downloadPdf}
                                                    records={records}
                                                    currentPage={currentPage}
                                                    navigate={this.searchAirlineWallet}
                                                    pageSize={pageSize}
                                                    totalCount={totalCount}
                                                    converter={this.converter}
                                                />
                                            </div>
                                        )}
                                        {!pageRequesting && !records && (
                                            <PageEmptyContent message="No record match your search!" />
                                        )}
                                    </CardBody>
                                </CardBody>
                            )}
                        <NotificationSystem ref="notificationSystem" />
                    </Card>
                </ViewContent>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    const { loggingIn, user } = state.authentication;
    const { pageRequesting, requesting } = state.api;
    const { alert, manifestReports, airlinesCarriers } = state;
    return {
        loggingIn,
        requesting,
        pageRequesting,
        alert,
        user,
        manifestReports,
        airlinesCarriers
    };
}

export default connect(mapStateToProps)(Wallets);


// WEBPACK FOOTER //
// ./src/views/airline-wallet-history/index.js